import {createSelector} from 'reselect';
import {getListingPage, getTranslations} from './store';
import {getBookingUrl} from './bookingUrl';
import {getTotals} from './priceDetails';
import {getListingLabels} from './listingLabels';
import {getCurrentError} from './tripAlert';
import getPriceStatus from './priceStatus';
import {getBookingType} from './listing';

// Determines if price should be shown
const getShowPrice = createSelector(
    [getListingPage, getCurrentError, getPriceStatus],
    (listingPage, currentError, priceStatus) => {
        const {loadingRate} = listingPage;

        const {isAvailable} = priceStatus;

        return !loadingRate && !currentError && isAvailable;
    }
);

const getBookingModalData = createSelector(
    [
        getCurrentError,
        getBookingType,
        getTotals,
        getTranslations,
        getBookingUrl,
        getListingLabels,
        getListingPage,
        getShowPrice
    ],
    (
        currentError,
        bookingType,
        totals,
        translations,
        bookingUrl,
        listingLabels,
        listingPage,
        showPrice
    ) => {
        const labels = {
            title: translations.bookingSummary,
            continueButton: translations.onlineBookingModalContinue,
            cancellationPolicyHeader: translations.cancellationPolicyHeader
        };

        if (!bookingType.onlineBookable) {
            labels.continueButton = listingLabels.contactButton;
        }

        return {
            labels,
            ctaEnabled:
                (!listingPage.loadingRate && bookingUrl && !!bookingUrl.length && !currentError) ||
                !bookingType.onlineBookable,
            showCancellationPolicy: totals && Object.keys(totals).length > 0,
            showPrice
        };
    }
);

export default getBookingModalData;

export {getBookingModalData, getShowPrice};
